// extracted by mini-css-extract-plugin
export default {"table":"MaterialTable_table__bGUaY","graph-container":"MaterialTable_graph-container__mDp2B"};